import { render, staticRenderFns } from "./PouchList.vue?vue&type=template&id=7fd6a18e&scoped=true&"
import script from "./PouchList.vue?vue&type=script&lang=js&"
export * from "./PouchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd6a18e",
  null
  
)

export default component.exports